export default __webpack_public_path__ + "static/Sash-1-902bc60b581b2610df7d0f79c37bc000.png";